import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import ChangePassResponsible from '../index';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';

import GraphQL from '../../../GraphQL';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import { changePass } from '../../../shared/queries/ChangePassResponsible';

const ChangePassResponsibleFormHandler = (props) => {
  const { t, dispatch } = props;
  const [listOfPassResponsible, setListOfPassResponsible] = useState([]);

  function showLoading() {
    dispatch(changeLoadingTrue());
  }
  function hideLoading() {
    dispatch(changeLoadingFalse());
  }
  const handleSubmit = (values) => {
    showLoading();
    const mutation = changePass(values);
    GraphQL(mutation, {})
      .then((res) => {
        if (res.changePass) {
          hideLoading();
          dispatch(reset('ChangePassResponsible'));
          setListOfPassResponsible(res.changePass);
          showNotificationAutoDestroy(
            'success',
            t('success.title'),
            t('success.successfully-saved')
          );
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  return (
    <ChangePassResponsible
      onSubmit={handleSubmit}
      showLoading={showLoading}
      hideLoading={hideLoading}
      listOfPassResponsible={listOfPassResponsible}
    />
  );
};

ChangePassResponsibleFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ChangePassResponsibleFormHandler)
);
